import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

import NewEditCaseProviderModal from "@/Components/BP/modals/NewEditCaseProviderModal";
import { useGetTreatmentDetailsPageData } from "@/Components/TreatmentPage/hooks/useApiResource";
import { setComponentLoadingEffect } from "@/Redux/common/Loader/action";

import { formatNum } from "../../../Utils/date";
import {
  formatCalendarDate,
  addClickRecord,
  formatPhoneNumber,
  getCaseId,
  getClientId,
} from "../../../Utils/helper";
import { showModal } from "../../../Redux/modal/actions";
import {
  fetchCasePageClientProviders,
  fetchClientProvider,
  fetchClientProviderVerifications,
} from "../../../api/clientProviders";
import {
  setClientProviders,
  setEditCaseProvider,
  setLoading,
  setVerifications,
} from "../../../Redux/client-providers/clientProviderSlice";
import "./MedicalProviders.css";

// eslint-disable-next-line import/no-unresolved
import MedicalProviderPlaceholder from "./MedicalProviderPlaceholder";
import { equalizeColumns } from "./utils";

// changes to this

export default function MedicalProviders({ id, refetchSpecial }) {
  const dispatch = useDispatch();
  const client_providers = useSelector((state) => state.clientProvider.all);
  // const show = useSelector((state) => state.modal.show);
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const [showEditProvider, setShowEditProvider] = useState(false);
  const { data, refetch: refetchTreatmentDetails } = useGetTreatmentDetailsPageData();
  const [editProviderData, setEditProviderData] = useState({});
  const filteredClientProviders = React.useMemo(() => {
    if (!client_providers) return [];

    if (id === "all") {
      return client_providers;
    }

    return client_providers.filter((provider) => String(provider?.specialty?.id) === String(id));
  }, [client_providers, id]);
  // const medicalProvidersLoading = useSelector(
  //   (state) => state?.loadEffect?.componentLoadStates?.medicalProviders
  // );

  // useEffect(() => {
  //   if (caseSummary && client) {
  //     setLoading({
  //       key: "all",
  //       value: true,
  //     });

  //     dispatch(setComponentLoadingEffect("medicalProviders", true));
  //     fetchCasePageClientProviders(getClientId(), getCaseId())
  //       .then((data) => {
  //         dispatch(setClientProviders(data?.results));
  //         setLoading({
  //           key: "all",
  //           value: false,
  //         });
  //         dispatch(setComponentLoadingEffect("medicalProviders", false));
  //       })
  //       .catch((error) => {
  //         console.error("Error occurred while fetching client-providers", error);
  //         dispatch(setComponentLoadingEffect("medicalProviders", false));
  //         setLoading({
  //           key: "all",
  //           value: false,
  //         });
  //       });
  //   }
  // }, [caseSummary, client, dispatch]);
  // const adjustCaseDetailsWidths = () => {
  //   const columnClasses = [
  //     "medical-small-provider-summary",
  //     "phone-small-provider-summary",
  //     "first-last-provider-summary",
  //     "visit-provider-summary",
  //     "record-bills-provider-summary",
  //     "original-lien-provider-summary",
  //   ];

  //   columnClasses.forEach((className) => {
  //     const elements = document.querySelectorAll(`.${className}`);

  //     let maxWidth = 0;

  //     elements.forEach((el) => {
  //       const width = el.getBoundingClientRect().width;
  //       maxWidth = Math.max(maxWidth, width);
  //     });

  //     elements.forEach((el) => {
  //       el.style.width = `${maxWidth}px`;
  //       el.style.minWidth = `${maxWidth}px`;
  //       // el.style.maxWidth = `${maxWidth}px`;
  //     });
  //   });
  // };

  // useEffect(() => {
  //   adjustCaseDetailsWidths();

  //   window.addEventListener("resize", adjustCaseDetailsWidths);
  //   return () => {
  //     window.removeEventListener("resize", adjustCaseDetailsWidths);
  //   };
  // }, [filteredClientProviders]);
  const tableRef = useRef(null);

  useEffect(() => {
    const table = tableRef.current;
    if (!table) return;
    const run = () =>
      equalizeColumns(tableRef.current, [
        "medical-small-provider-summary",
        "phone-small-provider-summary",
        "first-last-provider-summary",
        "visit-provider-summary",
        "record-bills-provider-summary",
        "original-lien-provider-summary",
      ]);
    const ro = new ResizeObserver(run);
    ro.observe(table);
    return () => ro.disconnect();
  }, [filteredClientProviders]);
  return (
    <>
      {showEditProvider && (
        <NewEditCaseProviderModal
          show={showEditProvider}
          handleClose={() => {
            addClickRecord(999, 8);
            setShowEditProvider(false);
            setEditProviderData({});
          }}
          visits={editProviderData?.visits}
          dates={[
            {
              date: editProviderData?.first_date?.split("T")[0],
            },
            {
              date: editProviderData?.second_date?.split("T")[0],
            },
          ]}
          setDates={() => {}}
          setVisits={() => {}}
          caseProvider={editProviderData}
          specialitie={editProviderData?.specialty}
          contact={editProviderData?.treatment_location}
          treatmentBill={editProviderData?.billing_request}
          paidBill={editProviderData?.billing_request_paid}
          treatmentRecord={editProviderData?.records_request}
          paidRecords={editProviderData?.records_request_paid}
          lienHolder={editProviderData?.lien_holder}
          verification={editProviderData?.verification?.verification_info}
          refetchAll={() => {
            setEditProviderData({});
            refetchTreatmentDetails(true);
            fetchCasePageClientProviders(getClientId(), getCaseId())
              .then((data) => {
                dispatch(setClientProviders(data?.results));
                setLoading({
                  key: "all",
                  value: false,
                });
                dispatch(setComponentLoadingEffect("medicalProviders", false));
              })
              .catch((error) => {
                console.error("Error occurred while fetching client-providers", error);
                dispatch(setComponentLoadingEffect("medicalProviders", false));
                setLoading({
                  key: "all",
                  value: false,
                });
              });
          }}
          activeTab={"Treatment-Location"}
          setActiveTab={() => {}}
        />
      )}
      <table
        className="table table-borderless table-striped table-treatment has-specialty-icon has-height-25"
        id="treatment-summary-table"
        ref={tableRef}
      >
        <thead>
          <tr id="tb-header">
            <th
              className="text-center"
              style={{
                minWidth: "25px",
                width: "25px",
                maxWidth: "25px",
              }}
            >
              {" "}
              {/* Index Header  */}
            </th>
            <th
              style={{
                minWidth: "25px",
                width: "25px",
                maxWidth: "25px",
              }}
              id="th-tf"
              className="text-center"
            >
              TF
            </th>
            <th className=" td-autosize color-grey-2 p-l-5 text-center medical-small-provider-summary">
              Medical Provider
            </th>
            <th className="td-autosize  text-center color-grey-2 phone-small-provider-summary">
              Phone
            </th>
            <th className="" />
            <th className="td-autosize  text-center color-grey-2 first-last-provider-summary">
              First / Last
            </th>
            <th className="" />
            <th className="td-autosize  text-center color-grey-2 visit-provider-summary">Visits</th>
            <th className="" />
            <th className="td-autosize  text-center color-grey-2 record-bills-provider-summary">
              Records / Bills
            </th>
            <th className="" />
            <th className="td-autosize text-center color-grey-2 original-lien-provider-summary">
              Original / Lien
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredClientProviders && filteredClientProviders.length > 0 ? (
            filteredClientProviders?.map((client_provider, index) => (
              <tr
                className={`height-50 has-speciality-color-${client_provider?.specialty?.id} ${index % 2 === 0 ? "bg-speciality-4" : "bg-speciality-4"}`}
                id="treatment-summary-row"
                data-table_id={36}
                onClick={() => {
                  if (!showEditProvider) {
                    addClickRecord(999, page_id_click_record);
                    dispatch(showModal());
                    setShowEditProvider(true);
                    const editData = data?.find((d) => d?.id === client_provider?.id);
                    setEditProviderData(editData);
                    dispatch(
                      setLoading({
                        key: "editCaseProvider",
                        value: true,
                      })
                    );
                    fetchClientProvider(client_provider.id)
                      .then((data) => {
                        dispatch(setEditCaseProvider(data));
                        dispatch(
                          setLoading({
                            key: "editCaseProvider",
                            value: false,
                          })
                        );
                      })
                      .catch(() => {
                        dispatch(
                          setLoading({
                            key: "editCaseProvider",
                            value: false,
                          })
                        );
                      });
                    fetchClientProviderVerifications(client_provider.id, "CaseProviders")
                      .then((verificationData) => {
                        dispatch(setVerifications(verificationData));
                      })
                      .catch((err) => {
                        console.error("Error Occurred fetchClientProviderVerifications", err);
                      });
                  }
                }}
              >
                <td
                  className="hover-white-treatment-summary"
                  id="index-summary"
                  style={{ height: "50px", color: "var(--primary-25)", fontWeight: "600" }}
                >
                  {index + 1}
                </td>
                <td
                  className="hover-white-treatment-summary color-black"
                  style={{ height: "50px" }}
                >
                  {/* TF */}
                </td>
                {client_provider.profile_pic ? (
                  <td
                    className={"td-autosize bg-speciality-10 color-black"}
                    style={{ height: "50px" }}
                    id="index-summary-provider"
                  >
                    <div className="d-flex align-items-center" style={{ width: "100%" }}>
                      <span
                        className="d-flex align-items-center justify-content-center text-center text-white specialty-icon flex-shrink-0"
                        style={{
                          backgroundColor: `${client_provider?.specialty?.color}`,
                          height: "50px",
                        }}
                      >
                        {client_provider?.specialty?.name[0]}
                      </span>
                      <p
                        className="p-l-5 text-start location-name-less-space"
                        // style={{
                        //   fontWeight: 600,
                        //   minWidth: "250px",
                        //   whiteSpace: "normal",
                        //   wordBreak: "break-word",
                        //   overflowWrap: "anywhere",
                        // }}
                      >
                        {client_provider?.treatment_location?.name
                          ? client_provider?.treatment_location?.name
                          : null}
                      </p>
                    </div>
                  </td>
                ) : (
                  <td
                    className=" td-autosize bg-speciality-10 color-black"
                    style={{ height: "50px" }}
                    id="index-summary-provider"
                  >
                    <div className="d-flex align-items-center" style={{ width: "100%" }}>
                      <span
                        className="d-flex align-items-start justify-content-center text-center text-white specialty-icon flex-shrink-0"
                        style={{
                          backgroundColor: `${client_provider?.specialty?.color}`,
                          height: "50px",
                        }}
                      >
                        <div
                          style={{
                            width: "25px",
                            height: "25px",
                          }}
                          className="d-flex align-items-center justify-content-center"
                        >
                          {client_provider?.specialty?.name[0]}
                        </div>
                      </span>
                      <p
                        className="p-l-5 text-start location-name-less-space"
                        style={{
                          height: "50px",
                        }}
                        // style={{
                        //   fontWeight: 600,
                        // minWidth: "250px",
                        //   whiteSpace: "normal",
                        //   wordBreak: "break-word",
                        //   overflowWrap: "anywhere",

                        // }}
                      >
                        {client_provider?.treatment_location?.name
                          ? client_provider?.treatment_location?.name
                          : null}
                      </p>
                    </div>
                  </td>
                )}

                <td
                  className="td-autosize hover-white-treatment-summary"
                  id="medicalProviderFinalBalance-padding-left"
                  style={{ fontWeight: "600", alignContent: "start" }}
                >
                  {client_provider?.treatment_location && (
                    <div className="height-25 d-flex align-items-center">
                      {formatPhoneNumber(client_provider?.treatment_location?.phone_number)}
                    </div>
                  )}
                </td>
                <td className="hover-white-treatment-summary" />
                <td
                  className="td-autosize hover-white-treatment-summary"
                  style={{ height: "50px" }}
                >
                  <div className="d-flex flex-column " style={{ height: "50px" }}>
                    {/* First Date */}
                    <div
                      className="d-flex align-items-center justify-content-end height-25"
                      style={{ gap: "5px" }}
                    >
                      {/* <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ width: "max-content" }}
                    >
                      {client_provider?.verification_details?.first_date?.verified ? (
                        client_provider?.verification_details?.first_date?.details[0]
                          ?.profile_pic ? (
                          <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img">
                            <img
                              src={
                                client_provider?.verification_details?.first_date.details[0]
                                  ?.profile_pic
                              }
                              alt={
                                client_provider?.verification_details?.first_date.details[0]?.date
                              }
                              className="ps-0"
                            />
                          </span>
                        ) : (
                          <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img" />
                        )
                      ) : (
                        <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img" />
                      )}
                    </div> */}
                      <div style={{ fontWeight: "600" }}>
                        {/* {client_provider?.bp_treatment_notes &&
                        [...client_provider.bp_treatment_notes]
                          .sort((a, b) => new Date(a.date) - new Date(b.date))
                          .map((note, index) =>
                            index === 0 ? <span key={note.id}>{formatDate(note.date)}</span> : null
                          )} */}
                        {formatCalendarDate(client_provider?.first_date)}
                      </div>
                      {/* <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ width: "max-content" }}
                    >
                      {client_provider?.verification_details?.first_date?.verified ? (
                        <i className="ic ic-verified ic-19" />
                      ) : (
                        <i className="ic ic-unverified ic-19" />
                      )}
                    </div> */}
                    </div>

                    {/* Second Date */}
                    <div
                      className="d-flex align-items-center justify-content-end height-25"
                      style={{ gap: "5px" }}
                    >
                      {/* <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ width: "max-content" }}
                    >
                      {client_provider?.verification_details?.second_date?.verified ? (
                        client_provider?.verification_details?.second_date?.details[0]
                          ?.profile_pic ? (
                          <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img">
                            <img
                              src={
                                client_provider?.verification_details?.second_date?.details[0]
                                  ?.profile_pic
                              }
                              alt=""
                              className="ps-0"
                            />
                          </span>
                        ) : (
                          <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img" />
                        )
                      ) : (
                        <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img" />
                      )}
                    </div> */}
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ fontWeight: "600" }}
                      >
                        {/* {client_provider?.bp_treatment_notes &&
                        [...client_provider.bp_treatment_notes]
                          .sort((a, b) => new Date(a.date) - new Date(b.date))
                          .map((note, index) =>
                            index === client_provider.bp_treatment_notes.length - 1 ? (
                              <span key={note.id}>{formatDate(note.date)}</span>
                            ) : null
                          )} */}
                        {formatCalendarDate(client_provider?.second_date)}
                      </div>
                      {/* <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ width: "max-content" }}
                    >
                      {client_provider?.verification_details?.second_date?.verified ? (
                        <i className="ic ic-verified ic-19" />
                      ) : (
                        <i className="ic ic-unverified ic-19" />
                      )}
                    </div> */}
                    </div>
                  </div>
                </td>
                <td className="hover-white-treatment-summary" />
                <td
                  className="td-autosize hover-white-treatment-summary"
                  style={{ width: "19px", height: "50px", alignContent: "start" }}
                >
                  <div
                    className="d-flex align-items-center height-25 justify-content-center"
                    style={{ gap: "5px", fontWeight: "600" }}
                  >
                    {/* <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ width: "max-content" }}
                  >
                    {client_provider?.verification_details?.visits?.verified ? (
                      client_provider?.verification_details?.visits?.details[0]?.profile_pic ? (
                        <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img">
                          <img
                            src={
                              client_provider?.verification_details?.visits?.details[0]?.profile_pic
                            }
                            alt=""
                            className="ps-0"
                          />
                        </span>
                      ) : (
                        <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img" />
                      )
                    ) : (
                      <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img" />
                    )}
                  </div> */}
                    {client_provider?.visits === "_" ? "" : client_provider?.visits}
                    {/* <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ width: "max-content" }}
                  >
                    {client_provider?.verification_details?.visits?.verified ? (
                      <i className="ic ic-verified ic-19" />
                    ) : (
                      <i className="ic ic-unverified ic-19" />
                    )}
                  </div> */}
                  </div>
                </td>

                <td className="hover-white-treatment-summary" />
                <td
                  className="color-black td-autosize hover-white-treatment-summary"
                  style={{ height: "50px" }}
                >
                  <div className="d-flex flex-column">
                    <div
                      className="d-flex align-items-center height-25 justify-content-center"
                      style={{ gap: "5px" }}
                    >
                      {/* <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ width: "max-content" }}
                    >
                      {client_provider?.verification_details?.record_received?.verified ? (
                        client_provider?.verification_details?.record_received?.details[0]
                          ?.profile_pic ? (
                          <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img">
                            <img
                              src={
                                client_provider?.verification_details?.record_received?.details[0]
                                  ?.profile_pic
                              }
                              alt=""
                              className="ps-0"
                            />
                          </span>
                        ) : (
                          <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img" />
                        )
                      ) : (
                        <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img" />
                      )}
                    </div> */}
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ fontWeight: "600" }}
                      >
                        {client_provider?.record_received ? (
                          <span>
                            Received {formatCalendarDate(client_provider?.record_received)}
                          </span>
                        ) : (
                          <span>Waiting</span>
                        )}
                      </div>
                      {/* <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ width: "max-content" }}
                    >
                      {client_provider?.verification_details?.record_received?.verified ? (
                        <i className="ic ic-verified ic-19" />
                      ) : (
                        <i className="ic ic-unverified ic-19" />
                      )}
                    </div> */}
                    </div>

                    <div
                      className="d-flex align-items-center height-25 justify-content-center"
                      style={{ gap: "5px" }}
                    >
                      {/* <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ width: "max-content" }}
                    >
                      {client_provider?.verification_details?.billing_received?.verified ? (
                        client_provider?.verification_details?.billing_received?.details[0]
                          ?.profile_pic ? (
                          <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img">
                            <img
                              src={
                                client_provider?.verification_details?.billing_received?.details[0]
                                  ?.profile_pic
                              }
                              alt=""
                              className="ps-0"
                            />
                          </span>
                        ) : (
                          <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img" />
                        )
                      ) : (
                        <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img" />
                      )}
                    </div> */}
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ fontWeight: "600" }}
                      >
                        {client_provider?.billing_received ? (
                          <span>
                            Received {formatCalendarDate(client_provider.billing_received)}
                          </span>
                        ) : (
                          <span>Waiting</span>
                        )}
                      </div>
                      {/* <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ width: "max-content" }}
                    >
                      {client_provider?.verification_details?.billing_received?.verified ? (
                        <i className="ic ic-verified ic-19" />
                      ) : (
                        <i className="ic ic-unverified ic-19" />
                      )}
                    </div> */}
                    </div>
                  </div>
                </td>

                <td className="hover-white-treatment-summary" />
                <td
                  className="td-autosize hover-white-treatment-summary"
                  style={{ height: "50px" }}
                >
                  <div className="d-flex flex-column">
                    {client_provider?.amount > 0 ? (
                      <div className="text-end height-25" style={{ fontWeight: "600" }}>
                        $ {formatNum(client_provider?.amount)}
                      </div>
                    ) : (
                      <div
                        className="text-end text-primary-50 height-25"
                        style={{ fontWeight: "600" }}
                      >
                        $ {formatNum(client_provider?.amount)}
                      </div>
                    )}
                    {client_provider?.final > 0 ? (
                      <div className="text-end height-25" style={{ fontWeight: "600" }}>
                        $ {formatNum(client_provider?.final)}
                      </div>
                    ) : (
                      <div
                        className="text-end text-primary-50 height-25"
                        style={{ fontWeight: "600" }}
                      >
                        $ {formatNum(client_provider?.final)}
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <MedicalProviderPlaceholder refetchSpecial={refetchSpecial} />
          )}
        </tbody>
      </table>
    </>
  );
}
